/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbMobileRefineMenuFilterDeliveryOptions_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterDeliveryOptions_viewer">;
    readonly " $refType": "SbMobileRefineMenuFilterDeliveryOptions_viewer";
};
export type SbMobileRefineMenuFilterDeliveryOptions_viewer$data = SbMobileRefineMenuFilterDeliveryOptions_viewer;
export type SbMobileRefineMenuFilterDeliveryOptions_viewer$key = {
    readonly " $data"?: SbMobileRefineMenuFilterDeliveryOptions_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbMobileRefineMenuFilterDeliveryOptions_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbMobileRefineMenuFilterDeliveryOptions_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterDeliveryOptions_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '751dcd31ef540c4b7c9b7f7e7777d0f2';
export default node;
